/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, September 18th 2022, 5:19:12 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { EmptyStateActionWrapper, Image, EmphasisText, OSActionButton, useToggleState } from "ui-widgets";
import { FieldDependencyFormModal } from "./FieldDependencyForm";

export const EmptyFieldDependenciesCTA = ({ form }) => {
  const { handleClose, handleOpen, open } = useToggleState();
  return (
    <>
      <EmptyStateActionWrapper
        title="No Field Dependencies"
        description={
          <>
            <EmphasisText>{form.title}</EmphasisText> does not currently have any field dependencies. Use field
            dependencies to implement conditional logic on the fields for the form
          </>
        }
        illustrationGraphic={<Image className="image-style-A" src="/img/decision-making.png" alt="Onestop Admin" />}
      >
        <OSActionButton onClick={handleOpen} variant="contained" size="large">
          Add New Field Dependency
        </OSActionButton>
        <FieldDependencyFormModal open={open} handleClose={handleClose} fieldDependencyId={null} />
      </EmptyStateActionWrapper>
    </>
  );
};
